// REACT_APP_VERSION is expanded from the client package.json version at build
// time (see .env.development / .env.production). 'dev' means the build ran
// outside npm scripts, where npm_package_version isn't set.
export const APP_VERSION: string = process.env.REACT_APP_VERSION || 'dev';
